import { Navigate, useLocation } from 'react-router-dom'
import useAuth from './useAuth'
import loadingImage from 'assets/images/boat-loading.gif'
import { t } from 'i18next'

export const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading, canAccessRoute, isNSAUser } = useAuth()
    const location = useLocation()

    if (isLoading) {
        return (
            <div className="flex flex-col justify-center items-center bg-white h-96 mt-16 w-full">
                <img alt="logo" src={loadingImage} className="w-[250px]" />
                <p className="pt-3 text-primary font-semibold">{t('Loading, please wait...')}</p>
            </div>
        )
    }

    if (!isAuthenticated) {
        return <Navigate to="/" />
    }

    if (!canAccessRoute(location.pathname)) {
        // Redirect NSA users to passenger-record instead of home
        if (isNSAUser()) {
            return <Navigate to="/passenger-record" />
        }
        return <Navigate to="/" />
    }

    return children
}
